import React from 'react';
import PropTypes from 'prop-types';

import Hat from '@components/atoms/Icon/svg/GraduateHat';
import Check from '@components/atoms/Icon/svg/Check';
import Arrow from '@components/atoms/Icon/svg/Arrow';
import Cross from "@components/atoms/Icon/svg/Cross";
import LightBulb from "@components/atoms/Icon/svg/LightBulb";
import Headset from "@components/atoms/Icon/svg/Headset";
import Calendar from "@components/atoms/Icon/svg/Calendar";
import ComputerScreen from "@components/atoms/Icon/svg/ComputerScreen";
import Hand from "@components/atoms/Icon/svg/Hand";
import GraduationCap from "@components/atoms/Icon/svg/GraduationCap";
import ComputerGraph from "@components/atoms/Icon/svg/ComputerGraph";

export const VARIANT_UP = 'up';
export const VARIANT_DOWN = 'down';
export const VARIANT_LEFT = 'left';

const Icon = ({ name, variant, type }) => {
  const sources = {
    check: Check,
    hat: Hat,
    arrow: Arrow,
    cross: Cross,
    lightbulb: LightBulb,
    headset: Headset,
    calendar: Calendar,
    computerscreen: ComputerScreen,
    hand: Hand,
    graduationcap: GraduationCap,
    computergraph: ComputerGraph,
  };
  if (Object.keys(sources).includes(name)) {
    const Svg = sources[name];
    return <Svg dataTestId={`test_svg_${name}`} variant={variant} type={type} alt={name} />;
  }
  return <></>;
};

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  variant: PropTypes.string,
  type: PropTypes.string,
};

export default Icon;
